module.exports = __webpack_public_path__ + "img/tubal-ligation_x2.1b07b216.png";